import React from 'react';
import { createRoot } from 'react-dom/client';
import './i18n';

import './styles/styles.css';
import './styles/datepicker-styles.css';
import './components/VirtualClipper/styles/video-js.min.css';
import './components/VirtualClipper/styles/video-player.css';
import './components/VirtualClipper/styles/video-player-seek-buttons.css';

import App from './components/App';

import { unregister } from './serviceWorker';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);

unregister();
